import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import Navbar from "../Navbar/Navbar";

export default class PlotMenu extends Component {
    state = {
        nameArr: [],
        plotName: '',
        redirectBool: false
    };

    componentDidMount() {
        document.title = 'Plot Menu';
    }

    constructor(props) {
        super(props);
        fetch(`http://iotjokebase.herokuapp.com/getplotmenu?uuidMine=${localStorage.getItem('uuid')}`).then(res => {
            res.json().then(jsnRes => {
                this.setState({nameArr: jsnRes});
            }).catch(jsnErr => {
                console.log('JSON Error : ' + jsnErr.message);
            });
        }).catch(err => {
            console.log('Fetch Error : ' + err.message);
        });
    }

    onPlotSelect = (e) => {
        console.log(e.target.value);
        this.setState({plotName: e.target.value});
        this.setState({redirectBool: true});
    };

    listPlots = () => {
        return this.state.nameArr.map((dat, key) => {
            // return(<button key={key} onClick={this.onPlotSelect} value={dat.PLOTNAME}>{dat.PLOTNAME}</button>);
            return (<tr key={key}>
                <th>{dat.PLOTNAME}</th>
                <td>
                    <button className='btn btn-outline-primary' value={dat.PLOTNAME} onClick={this.onPlotSelect}>GO
                    </button>
                </td>
            </tr>);
        })
    };

    redirectToPlot = () => {
        if (this.state.redirectBool) {
            localStorage.setItem('plotItem', this.state.plotName);
            return (<Redirect to='/plot'/>);
        }
    };
    redirectToLogin = () => {
        if (localStorage.getItem('uuid') === 'undefined'|| localStorage.getItem('uuid') === null) {
            return (<Redirect to='/'/>);
        }
    };

    render() {
        return (<div>
            {this.redirectToLogin()}
            <Navbar/>
            {this.redirectToPlot()}
            <table className='table table-bordered'>
                <tbody>
                {this.listPlots()}
                </tbody>
            </table>
        </div>);
    }
}


// <table style="width: 100%;padding-top: 10px;margin-top: 20px" className="table table-bordered">
//     <th>{{plot.plotId.Name}}</th>
//     <tr>
//         <td>
//             <button className="btn btn-outline-success align-content-center"
//                     style="margin-left: 10px ; margin-top: 10px"
//             (click)="Clicked(plot.plotId.Name,plot.plotId.Id,'GO')"><span
//                 class="badge badge-pill badge-primary">GO</span>
//               </button>
//             </td>
//             <td>
//               <button class="btn btn-outline-danger align-content-center" style="margin-left: 10px ; margin-top: 10px"
//                       (click)="Clicked(plot.plotId.Name,plot.plotId.Id,' DELETE')">
//                 <span class="badge badge-pill badge-danger">DELETE</span>
//               </button>
//             </td>
//           </tr>
//         </table>
